<template>
  <v-dialog v-model="isShow" max-width="500">
    <v-card>
      <v-form ref="form" @submit.prevent>
        <v-card-title>User Information</v-card-title>
        <v-card-text>
          <v-container>
            <v-text-field
              v-model="givenName"
              label="Given Name"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model="surname"
              label="Surname"
              :rules="[rules.required]"
            >
            </v-text-field>
            <v-text-field
              v-model="organization"
              label="Organization"
              :rules="[rules.required]"
            >
            </v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="isShow = false">Close</v-btn>
          <v-btn type="submit" text @click="saveUserInfo">Save</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UserInfoDialog",
  props: {
    isNoUserInfo: Boolean,
  },
  data: () => ({
    givenName: "",
    surname: "",
    organization: "",
    rules: {
      required: (value) => !!value || "Required",
    },
  }),
  computed: {
    isShow: {
      get() {
        return this.isNoUserInfo;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    saveUserInfo() {
      this.$refs.form.validate().then((isValid) => {
        if (isValid.valid) {
          this.$emit("save", this.givenName, this.surname, this.organization);
        }
      });
    },
    async getUserInfo() {
      await this.$store.dispatch("user/getUserInfo");
    },
  },
  async mounted() {
    await this.getUserInfo();

    this.givenName = this.$store.getters["user/givenName"];
    this.surname = this.$store.getters["user/surname"];
    this.organization = this.$store.getters["user/organization"];
  },
};
</script>